import { useState, useEffect } from 'react';

const Portfolio = () => {
  useEffect(() => {
    document.title = 'Portofolio - CV Samudera Alam Perkasa';
    window.scrollTo(0, 0);
  }, []);

  const [activeFilter, setActiveFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: 'Rekrutmen Tenaga Konstruksi',
      category: 'construction',
      image: 'https://images.pexels.com/photos/159306/construction-site-build-construction-work-159306.jpeg?auto=compress&cs=tinysrgb&w=1600',
      client: 'PT Konstruksi Jaya',
      location: 'Jakarta',
      year: '2023',
      description: 'Penyediaan 150+ tenaga kerja terampil untuk proyek pembangunan gedung perkantoran dengan kebutuhan tenaga kerja multidisiplin.',
    },
    {
      id: 2,
      title: 'Manajemen SDM Pabrik',
      category: 'manufacturing',
      image: 'https://images.pexels.com/photos/2760243/pexels-photo-2760243.jpeg?auto=compress&cs=tinysrgb&w=1600',
      client: 'PT Industri Manufaktur',
      location: 'Surabaya',
      year: '2022',
      description: 'Pengelolaan komprehensif untuk 200+ tenaga kerja pabrik termasuk rekrutmen, administrasi, dan program kesejahteraan.',
    },
    {
      id: 3,
      title: 'Pelatihan Tenaga Administrasi',
      category: 'training',
      image: 'https://images.pexels.com/photos/7173026/pexels-photo-7173026.jpeg?auto=compress&cs=tinysrgb&w=1600',
      client: 'PT Mitra Solusi',
      location: 'Bandung',
      year: '2023',
      description: 'Program pelatihan intensif untuk meningkatkan keterampilan administratif dan teknologi informasi bagi 50 staf.',
    },
    {
      id: 4,
      title: 'Penyediaan Tenaga IT',
      category: 'technology',
      image: 'https://images.pexels.com/photos/7108/notebook-computer-chill-relax.jpg?auto=compress&cs=tinysrgb&w=1600',
      client: 'PT Teknologi Terdepan',
      location: 'Jakarta',
      year: '2022',
      description: 'Rekrutmen dan penempatan 30 profesional IT dengan berbagai keahlian spesifik untuk proyek transformasi digital.',
    },
    {
      id: 5,
      title: 'Manajemen Tenaga Pemasaran',
      category: 'sales',
      image: 'https://images.pexels.com/photos/3182812/pexels-photo-3182812.jpeg?auto=compress&cs=tinysrgb&w=1600',
      client: 'PT Distribusi Global',
      location: 'Semarang',
      year: '2023',
      description: 'Penyediaan dan pengelolaan tim pemasaran 75 orang dengan fokus pada peningkatan kinerja penjualan di wilayah Jawa Tengah.',
    },
    {
      id: 6,
      title: 'Konsultasi Reorganisasi SDM',
      category: 'consulting',
      image: 'https://images.pexels.com/photos/3182781/pexels-photo-3182781.jpeg?auto=compress&cs=tinysrgb&w=1600',
      client: 'PT Sukses Mandiri',
      location: 'Surabaya',
      year: '2022',
      description: 'Konsultasi untuk restrukturisasi departemen SDM dan implementasi sistem manajemen kinerja baru.',
    },
    {
      id: 7,
      title: 'Rekrutmen Staff Perhotelan',
      category: 'hospitality',
      image: 'https://images.pexels.com/photos/1134176/pexels-photo-1134176.jpeg?auto=compress&cs=tinysrgb&w=1600',
      client: 'Pesona Resort',
      location: 'Bali',
      year: '2023',
      description: 'Penyediaan 100+ tenaga kerja untuk berbagai posisi di resort baru, termasuk front office, housekeeping, dan F&B.',
    },
    {
      id: 8,
      title: 'Pelatihan Keselamatan Kerja',
      category: 'training',
      image: 'https://images.pexels.com/photos/8297452/pexels-photo-8297452.jpeg?auto=compress&cs=tinysrgb&w=1600',
      client: 'PT Industri Kimia',
      location: 'Cikarang',
      year: '2022',
      description: 'Program pelatihan keselamatan kerja komprehensif untuk 120 pekerja pabrik dengan sertifikasi standar internasional.',
    },
    {
      id: 9,
      title: 'Manajemen Tenaga Kesehatan',
      category: 'healthcare',
      image: 'https://images.pexels.com/photos/263337/pexels-photo-263337.jpeg?auto=compress&cs=tinysrgb&w=1600',
      client: 'RS Sehat Sentosa',
      location: 'Yogyakarta',
      year: '2023',
      description: 'Penyediaan dan pengelolaan 50+ tenaga kesehatan termasuk perawat, teknisi, dan staf administratif rumah sakit.',
    },
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  const [selectedProject, setSelectedProject] = useState(null);

  const openProjectDetails = (project) => {
    setSelectedProject(project);
    document.body.style.overflow = 'hidden';
  };

  const closeProjectDetails = () => {
    setSelectedProject(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      {/* Page Header */}
      <div className="bg-navy-900 text-white py-20 mt-16">
        <div className="container-custom">
          <h1 className="text-4xl font-bold mb-4">Portofolio Kami</h1>
          <p className="text-lg text-gray-300 max-w-3xl">
            Berikut adalah proyek-proyek yang telah kami kerjakan untuk berbagai klien di berbagai industri.
          </p>
        </div>
      </div>

      {/* Portfolio Section */}
      <section className="py-16">
        <div className="container-custom">
          {/* Filter Tabs */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {[
              { id: 'all', label: 'Semua' },
              { id: 'construction', label: 'Konstruksi' },
              { id: 'manufacturing', label: 'Manufaktur' },
              { id: 'training', label: 'Pelatihan' },
              { id: 'technology', label: 'Teknologi' },
              { id: 'consulting', label: 'Konsultasi' },
              { id: 'sales', label: 'Pemasaran' },
              { id: 'hospitality', label: 'Perhotelan' },
              { id: 'healthcare', label: 'Kesehatan' },
            ].map((filter) => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className={`px-5 py-2 rounded-md font-medium transition-all ${
                  activeFilter === filter.id
                    ? 'bg-primary-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>

          {/* Projects Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project) => (
              <div key={project.id} className="card group overflow-hidden">
                <div className="relative overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-navy-900/70 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <button 
                      onClick={() => openProjectDetails(project)}
                      className="px-6 py-3 bg-yellow-500 text-white rounded-md transform translate-y-8 group-hover:translate-y-0 transition-transform duration-300"
                    >
                      Lihat Detail
                    </button>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2 text-navy-900 group-hover:text-primary-600 transition-colors">
                    {project.title}
                  </h3>
                  <p className="text-gray-600 mb-2">Klien: {project.client}</p>
                  <div className="flex justify-between text-sm text-gray-500">
                    <span>{project.location}</span>
                    <span>{project.year}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* No Results Message */}
          {filteredProjects.length === 0 && (
            <div className="text-center py-12">
              <p className="text-xl text-gray-600">Tidak ada proyek yang ditemukan untuk kategori ini.</p>
            </div>
          )}
        </div>
      </section>

      {/* Industries Section */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
              Industri yang Kami Layani
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
              Kami telah berpengalaman menyediakan solusi tenaga kerja untuk berbagai sektor industri.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 text-center">
            {[
              'Konstruksi',
              'Manufaktur',
              'Teknologi Informasi',
              'Perhotelan',
              'Kesehatan',
              'Pendidikan',
              'Ritel',
              'Logistik',
              'Perbankan',
              'Minyak & Gas',
              'Pertambangan',
              'Pertanian',
            ].map((industry, index) => (
              <div 
                key={index} 
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all hover:bg-primary-50"
              >
                <p className="font-semibold text-navy-900">{industry}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Project Modal */}
      {selectedProject && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              <img
                src={selectedProject.image}
                alt={selectedProject.title}
                className="w-full h-64 object-cover"
              />
              <button
                onClick={closeProjectDetails}
                className="absolute top-4 right-4 bg-white rounded-full p-2 shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-navy-900"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            
            <div className="p-6">
              <h3 className="text-2xl font-bold mb-4 text-navy-900">{selectedProject.title}</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <h4 className="font-semibold text-navy-900 mb-2">Detail Proyek</h4>
                  <ul className="space-y-2">
                    <li className="flex items-start">
                      <span className="font-medium mr-2">Klien:</span>
                      <span>{selectedProject.client}</span>
                    </li>
                    <li className="flex items-start">
                      <span className="font-medium mr-2">Lokasi:</span>
                      <span>{selectedProject.location}</span>
                    </li>
                    <li className="flex items-start">
                      <span className="font-medium mr-2">Tahun:</span>
                      <span>{selectedProject.year}</span>
                    </li>
                    <li className="flex items-start">
                      <span className="font-medium mr-2">Kategori:</span>
                      <span className="capitalize">{selectedProject.category}</span>
                    </li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="font-semibold text-navy-900 mb-2">Deskripsi</h4>
                  <p className="text-gray-600">{selectedProject.description}</p>
                </div>
              </div>
              
              <div className="mt-6 pt-6 border-t border-gray-200 flex justify-between">
                <span className="text-sm text-gray-500">Proyek ID: {selectedProject.id}</span>
                <button
                  onClick={closeProjectDetails}
                  className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
                >
                  Tutup
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Portfolio;